module.exports = __webpack_public_path__ + "06_face.5d7feb9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer1/06_face.png
// module id = Y3o0
// module chunks = 0